/** API route map: URLS.Controller.PrenoteConfiguration */
export const PrenoteConfiguration = {
      Name: 'PrenoteConfiguration/',
      Get: 'get',
      Add: 'add',
      Update: 'update',
};
